var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBlogFooter = function SvgIconBlogFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m15.914 16.836-2.546.903a.476.476 0 0 1-.607-.608l.903-2.545a.094.094 0 0 1 .024-.037l6.734-6.735a.852.852 0 0 1 1.204 0l1.06 1.06a.851.851 0 0 1 0 1.204l-6.735 6.734a.094.094 0 0 1-.037.024Zm2.586-.45v2.364A2.247 2.247 0 0 1 16.25 21h-12A2.247 2.247 0 0 1 2 18.75V8.25h15.865l-5.238 5.238a1.597 1.597 0 0 0-.377.597l-.903 2.545a1.976 1.976 0 0 0 2.523 2.523l2.545-.903c.225-.08 2.085-1.865 2.085-1.865Zm-12.75.864h2.377a.75.75 0 0 0 0-1.5H5.75a.75.75 0 0 0 0 1.5Zm0-3h3.877a.75.75 0 0 0 0-1.5H5.75a.75.75 0 0 0 0 1.5Zm0-3h6.877a.75.75 0 0 0 0-1.5H5.75a.75.75 0 0 0 0 1.5ZM2 6.75v-1.5A2.247 2.247 0 0 1 4.25 3h12a2.247 2.247 0 0 1 2.25 2.25v1.5H2Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconBlogFooter;